import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';

const TableCell = ({ children, className }) => {
  return (
    <td className={className} data-testid="table-cell">
      {children}
    </td>
  );
};

// === TableCell CSS ===
const StyledTableCell = styled(TableCell)`
  font-weight: ${vars.fontWeightRegular};
  padding: ${vars.spacingM} ${vars.spacingS};
`;

export default StyledTableCell;
